import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { body2Regular, body2SemiBold } from "shared/styles/typography";

import { ContentFrameGroupProps } from "./types";

const ContentFrameGroup = ({
    title,
    description,
    buttonText,
    buttonColor,
    icon,
    isLoading,
    onButtonClick
}: ContentFrameGroupProps) => {
    const { textDark, textSecondary } = colors;

    return (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                columnGap: "16px",
                padding: "16px 0",

                "& > svg": {
                    color: textDark,
                    alignSelf: "flex-start"
                }
            })}
        >
            {icon}

            <div
                css={css({
                    flex: "1"
                })}
            >
                <div css={body2SemiBold}>{title}</div>

                <div
                    css={[
                        body2Regular,
                        { color: textSecondary, marginTop: "4px" }
                    ]}
                >
                    {description}
                </div>
            </div>

            <Button
                variant={BUTTON_VARIANTS.TextOnly}
                color={buttonColor}
                size={BUTTON_SIZES.Small}
                isLoading={isLoading}
                onClick={onButtonClick}
            >
                {buttonText}
            </Button>
        </div>
    );
};

export default ContentFrameGroup;
